<template>
  <layout-component>
    <div class="container">
      <div class="row form-wrapper pb-4 pb-md-2">
        <div class="col-md-7 col-lg-8 form form-login">
          <h1 class="br-title left-bullet" v-html="$t('title-banner')"></h1>
          <p class="br-title p-intro" v-html="$t('text-01')"></p>
          <div class="row">
            <div class="col-lg-9">

              <b-alert :show="has_error && !success" fade variant="danger">
                <h4><i class="fal fa-times"></i> {{'error-title'|t}}.</h4>
                <p>{{'error-text'|t}}</p>
              </b-alert>

              <b-alert :show="! has_error && success" fade variant="success">
                <h4><i class="fal fa-times"></i> {{'success-title'|t}}.</h4>
                <p>{{'success-text'|t}}</p>
              </b-alert>


              <form autocomplete="off" @submit.prevent="send" method="post">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <label for="email">{{'email-address'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="email" class="form-control" placeholder="user@example.com" v-model="email" required>
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center pt-2">
                  <button type="submit" class="btn btn-primary mt-0"><span>{{'btn-submit'|t}}</span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        email: null,
        password: null,
        has_error: false,
        success: false,
        redirectTo: null
      }
    },

    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
    },

    methods: {
      send() {
        this.has_error = false;
        this.success = false;
        Vue.axios.post('/password/email', {
          email: this.email
        }).then(({data}) => {
          this.success = true;
        }).catch(({error}) => {
          this.has_error = true;
        })
      }
    }
  }
</script>


<i18n>
    {
      "en": {

        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim td'>Reset</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>Password</span></span>",
        "text-01": "Please enter your email address. You'll receive an email containing a reset link.",
        "email-address": "Email address",
        "btn-submit": "Reset",
        "error-title": "Error",
        "error-text": "This email address is invalid",
        "success-title": "Success",
        "success-text": "We have e-mailed your password reset link!"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim td'>Reinitialiser</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>le mot de passe</span></span>",
        "text-01": "Veuillez entrer votre adresse email. Vous recevrez un email contenant un lien de réinitialisation",
        "email-address": "Adresse email",
        "btn-submit": "Reinitialiser",
        "error-title": "Erreur",
        "error-text": "Cette adresse email est invalide",
        "success-title": "Succès",
        "success-text": "Nous vous avons envoyé un email avec un lien de réinintialisation!"
      }
    }

  </i18n>
